import React, { PureComponent, PropTypes } from 'react';
import { includes as _includes, map as _map } from 'lodash';

import BookingItem from './BookingItem';
import BookingDateItem from './BookingDateItem';
import BookingPersonsItem from './BookingPersonsItem';
import BookingAdditionalPlantItem from './BookingAdditionalPlantItem';
import BookingLabelValueItem from './BookingLabelValueItem';

import './BookingDetails.css';

export default class BookingDetails extends PureComponent {
    static propTypes = {
        user: PropTypes.object.isRequired,
        person: PropTypes.object.isRequired,
        persons: PropTypes.object.isRequired,
        costCentres: PropTypes.object.isRequired,
        plant: PropTypes.object.isRequired,
        locations: PropTypes.object.isRequired,
        booking: PropTypes.object.isRequired,
        bookingTimes: PropTypes.object.isRequired,
        startTimeOnClick: PropTypes.func,
        endTimeOnClick: PropTypes.func,
    }

    render() {
        const {
            user,
            person,
            persons,
            costCentres,
            plant,
            locations,
            booking,
            bookingTimes,
            startTimeOnClick,
            endTimeOnClick,
        } = this.props;

        // Driver/Passenger JSX
        const userIsPassenger = _includes(booking.passengerPersonIds, user.personId);
        const passengerNoteJsx = userIsPassenger
            ? <BookingItem title="IMPORTANT" value="You are a passenger for this booking." />
            : null;
        const driverJsx = userIsPassenger
            ? <BookingItem title="Driver"><BookingPersonsItem personIds={[booking.driverPersonId]} persons={persons} /></BookingItem>
            : null;
        const passengersJsx = booking.passengerPersonIds && booking.passengerPersonIds.length
            ? (<BookingItem title="Passengers" extraCssClasses="single-lines"><BookingPersonsItem personIds={booking.passengerPersonIds} persons={persons} /></BookingItem>)
            : null;

        // Locations JSX
        const journeyToJsx = booking.journeyToLocation
           ? <BookingItem title="Journey To" value={booking.journeyToLocation} />
           : (booking.journeyToLocationId ? <BookingItem title="Journey To" value={locations[booking.journeyToLocationId].name} /> : null);

        // Additional plant JSX
        const additionalPlantJsx = booking.additionalPlantIds && booking.additionalPlantIds.length
            ? <BookingItem title="Additional Plant"><BookingAdditionalPlantItem additionalPlantIds={booking.additionalPlantIds} plant={plant} /></BookingItem>
            : null;

        // Cost Centre JSX
        const hasCostCentres = booking.costCentreIds && booking.costCentreIds.length;
        const costCentreChildrenJsx = hasCostCentres > 0 ?
            _map(booking.costCentreIds, (id) => {
                return (
                    <div key={id} className="cost-centre-container">
                        <h2 className="cost-centre-id">
                            {costCentres[id].name}
                        </h2>

                        <div className="cost-centre-description">
                            {costCentres[id].description}
                        </div>
                    </div>
                );
            }) : null;
        const costCentreDescriptionJsx = hasCostCentres > 0 ? (
            <BookingItem title="Cost Centres">
                <div>{costCentreChildrenJsx}</div>
            </BookingItem>) : null;

        // Additional properties JSX
        const privateUseJsx = person.requirements.privateUse ? (
            <BookingLabelValueItem label="Private Use" >
                {booking.privateUse ? `Yes` : `No` }
            </BookingLabelValueItem>)
            : null;

        const additionalPropertiesJsx = privateUseJsx ? (
            <BookingItem title="Additional Properties">
                {privateUseJsx}
            </BookingItem>)
            : null;

        return (
            <div>
                {passengerNoteJsx}
                {driverJsx}
                <BookingItem title="Pickup From" value={locations[booking.pickupLocationId].name} extraCssClasses="single-lines">
                    <BookingDateItem date={bookingTimes.start} onClick={startTimeOnClick} />
                </BookingItem>
                {journeyToJsx}
                <BookingItem title="Return To" value={locations[booking.returnToLocationId].name} extraCssClasses="single-lines">
                    <BookingDateItem date={bookingTimes.end} onClick={endTimeOnClick} />
                </BookingItem>
                {additionalPlantJsx}
                {passengersJsx}
                {costCentreDescriptionJsx}
                <BookingItem title="Reason for Travel" value={booking.reasonForTravel} />
                {additionalPropertiesJsx}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./scripts/components/Booking/BookingDetails.jsx